module.exports = __webpack_public_path__ + "img/swiper1.5310fa5f.png";